import React from 'react';
import './styling/Products.css';
import { Link} from 'react-router-dom';
import product1_ups from './styling/images/home/products_slides/product1_ups.png'
import product2_stabilizer from './styling/images/home/products_slides/product2_stabilizer.png'
import product3_lineconditioner from './styling/images/home/products_slides/product3_linecoditioner.png'
import product4_solar from './styling/images/home/products_slides/product4_solar.png'
import product5_manualregulator from './styling/images/home/products_slides/product5_manualregulator.png'
import product6_battery from './styling/images/home/products_slides/product6_battery.png'
import product7_transformer from './styling/images/home/products_slides/product7_transformer.png'
 
const Products = () => {
   

  return (
  <div className='product'> 
  
  <h1 className='products-heading'>PRODUCTS</h1>
      <div className="row">
        <Link to="/product_items/Ups" className="image">
        <img src={product1_ups}  alt="UPS"/>
      </Link>
          <div className="text">
            <div className='heading'>UPS</div>
             
            <div className='para'>
            At Arose, we provide a wide range of uninterruptible power supplies (UPS) and inverters, including single-phase and three-phase options. We offer online and line-interactive UPS with short and long backup options, delivering pure sine wave output for reliable power. With a user-friendly display, our UPS systems are ideal for offices, banks, laboratories, telecommunications, hospitals, industries, and more, ensuring stable power for critical loads.
            </div>
          </div> 
      </div>

      <div className="row">
        
        <div className="text"> 
        
        
        <div className='heading'>VOLTAGE STABILIZER</div>
             
            <div className='para'>
            Arose offers a comprehensive range of automatic voltage regulators (AVR), including single-phase and three-phase stabilizers. Our relay, servo motor, and static type AVRs deliver stable, distortion-free output with high voltage and surge protection. These low-maintenance systems are designed for offices, hospitals, and industries, ensuring reliable voltage regulation for sensitive equipment and operations.
            </div>
            </div>
            <Link to="/product_items/Stabilizer" className="image">
        <img src={product2_stabilizer}  alt="Stabilizer"/>
      </Link>
      </div>
      <div className="row">
      <Link to="/product_items/LineConditioner" className="image">
        <img src={product3_lineconditioner}  alt="Solar"/>
      </Link>
          <div className="text">
            
            
            <div className='heading'>LINE CONDITIONER</div>
             
            <div className='para'>
            Our power line conditioners (PLC) at Arose are designed to provide stable, noise-free power for sensitive loads. Available in single-phase and three-phase units, these heavy-duty conditioners offer reliable performance for a wide range of environments, including offices, hospitals, laboratories, and industries, ensuring protection for critical systems against power fluctuations.
            </div>
            </div>
      </div>
      <div className="row">
      <div className="text">
            
      <div className='heading'>SOLAR</div>
             
            <div className='para'>
            Arose offers complete solar solutions, including solar inverters, panels, and batteries, from sales to installation and after-sales support. Our hybrid and on-grid systems feature built-in Wi-Fi, smart operation, and protection from high voltage and surges. With low maintenance, these solar solutions are perfect for offices, hospitals, industries, and more, promoting energy efficiency and sustainability.
            </div>
            </div>
      <Link to="/product_items/Solar" className="image">
        <img src={product4_solar}  alt="Solar"/>
      </Link>
 
      </div>
      <div className="row">
      <Link to="/product_items/ManualRegulator" className="image">
        <img src={product5_manualregulator}  alt="Solar"/>
      </Link>
          <div className="text">
            
            
            <div className='heading'>MANUAL REGULATOR</div>
             
            <div className='para'>
            Also known as a variac, our manual voltage regulators provide variable voltage output with stable, precise control. Available in various ranges and capacities, these regulators come with a friendly display and built-in protection, ensuring reliability for applications requiring adjustable voltage in offices, industries, and other settings.
            </div>
            </div>
      </div>
      <div className="row">
        
        <div className="text">
        
        
        <div className='heading'>BATTERY</div>
            <div className='para'>
            At Arose, we offer a wide selection of batteries, including dry cell, lead-acid, lithium-ion, Li-Po, and tubular batteries, across various capacities. We carry multiple trusted brands to meet diverse energy storage needs, providing reliable power solutions for industries, offices, telecommunications, and more.
            </div>
            </div>
        
            <Link to="/product_items/Battery" className="image">
        <img src={product6_battery}  alt="Battery"/>
      </Link>
      </div>
      <div className="row">
      <Link to="/product_items/Transformer" className="image">
        <img src={product7_transformer}  alt="Solar"/>
      </Link>
          <div className="text">
            
            
            <div className='heading'>TRANSFORMER</div>
            <div className='para'>
            Arose specializes in custom-made transformers tailored to your specific requirements. We provide all types of transformers, including step-up, step-down, auto, and isolation transformers. Our solutions ensure efficient voltage transformation for a variety of applications in offices, industries, telecommunications, and more.
            </div>
            </div>
      </div>
    </div>
    
    
    
    
    
    );
};

export default Products;
